import { BannerFieldsFragment } from '../../../@types/generated';
import { Paragraph, Label } from '../../../../../packages/components/src/typography';
import TextWithInlineColor from '../TextWithInlineColor';
import clsx from 'clsx';
import ImageDesktop, { ImageMobile } from '@/components/Banner/BannerImage';
import ButtonSection from './ButtonSection';

type Props = {
  data: BannerFieldsFragment;
  priority?: boolean;
};

const renderHeading = ({ data }: Props) => {
  return (
    <TextWithInlineColor
      heading={data.heading?.text?.json}
      color={data.heading?.color}
      textColor={data.heading?.textColor}
      headingVariant={'xl'}
    />
  );
};

const HeroHomePage = ({ data, priority }: Props) => {
  return (
    <div
      className={
        'col-span-12 grid gap-x-16 px-40 md:col-span-12 md:col-start-2 md:grid-cols-10 md:gap-x-24 md:px-16' +
        ` pt-${data.marginTop === 0 ? data.marginTop : data.marginTop || 32}` +
        ` pb-${data.marginBottom === 0 ? data.marginBottom : data.marginBottom || 32}`
      }
    >
      <ImageMobile
        image={data.image}
        isImageFade={data.isImageFade}
        bannerType={'heroSubPage'}
        priority={priority}
        video={data.video}
      />
      {data.imagePosition === 'left' && (
        <ImageDesktop
          image={data.image}
          imagePosition="left"
          isImageFade={data.isImageFade}
          bannerType="heroSubPage"
          priority={priority}
          video={data.video}
        />
      )}
      <div
        className={`grid gap-16 p-32 md:col-span-5 md:my-32 md:place-self-center md:p-0 ${clsx({
          'md:col-start-7': data.imagePosition === 'left',
          'md:col-start-1': data.imagePosition === 'right',
        })}`}
      >
        {data.tagline && <Label>{data.tagline}</Label>}
        {data.heading?.text && renderHeading({ data })}
        {data.description && (
          <Paragraph variant={'medium'} classes="whitespace-break-spaces text-black-100">
            {data.description}
          </Paragraph>
        )}
        {data.subdescription && <Paragraph variant="small">{data.subdescription}</Paragraph>}
        <ButtonSection data={data.button} classes="grid md:mt-16 md:flex md:w-fit" />
      </div>
      {data.imagePosition === 'right' && (
        <ImageDesktop
          image={data.image}
          imagePosition="right"
          isImageFade={data.isImageFade}
          bannerType="heroSubPage"
          priority={priority}
          video={data.video}
          media={data?.media}
        />
      )}
    </div>
  );
};
export default HeroHomePage;
